import React from 'react';
import { CardsContainer } from './Card';
import Card, { CardTitle, CardSubtitle, CardDescription } from './Card';
function renderCards(count) {
  var cards = [];
  for (var i = 0; i < count; i++) {
    cards.push(/*#__PURE__*/React.createElement(Card, {
      key: i,
      type: "placeholder"
    }, /*#__PURE__*/React.createElement(CardSubtitle, null), /*#__PURE__*/React.createElement(CardTitle, null), /*#__PURE__*/React.createElement(CardDescription, null)));
  }
  return /*#__PURE__*/React.createElement(CardsContainer, null, cards);
}
var loadingCards = function loadingCards(_ref) {
  var _ref$count = _ref.count,
    count = _ref$count === void 0 ? 3 : _ref$count;
  return /*#__PURE__*/React.createElement("div", null, renderCards(count));
};
export default loadingCards;